import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-form-cmp',
  templateUrl: './form-cmp.component.html',
  styleUrls: ['./form-cmp.component.scss']
})
export class FormCmpComponent implements OnInit {

  @Input() data: any;
  @Input() flag: boolean;
  constructor() {}
  ngOnInit() {
  }
  stringifyjson(val) {
    return JSON.stringify(val);
  }
}
